import { type ReactElement } from 'react'
import * as S from './clinic.styled'
import logo from '../../assets/images/logo-amorsaude.png'
import check from '../../assets/images/check.svg'
import { Carousel } from '../carousel/carousel'
import image1 from './assets/image-32.png'
import arrow from './assets/arrow.svg'
import useDimensions from '../../hooks/useDimentions'

export function Clinic (): ReactElement {
  const { isDesktop } = useDimensions()

  return <S.Container>
    <S.Content>
      <S.TextContent>
        <figure>
          <img src={logo} alt="" />
        </figure>
        <h1>Clínica parceira com atendimento de excelência e o melhor: sem burocracia</h1>
        <h6>Tenha acesso à maior rede de clínicas particulares do país, com mais de 450 unidades</h6>
        <ul>
          <li>
            <img src={check} alt="" />
            Atendimento de qualidade e humanizado.
          </li>
          <li>
            <img src={check} alt="" />
            Agendamento pelo App. É rápido, é prático.
          </li>
          <li>
            <img src={check} alt="" />
            4.000 tipos de exames.
          </li>
          <li>
            <img src={check} alt="" />
            Mais de 2 milhões de exames por mês.
          </li>
          <li>
            <img src={check} alt="" />
            53 áreas médicas.
          </li>
          <li>
            <img src={check} alt="" />
            350 clínicas odontológicas.
          </li>
        </ul>
      </S.TextContent>
      <Carousel arrowImg={arrow} className="carousel" showArrows={isDesktop} showDots={!isDesktop}>
        <S.Slide>
          <img src={image1} alt="" />
        </S.Slide>
        <S.Slide>
          <img src={image1} alt="" />
        </S.Slide>
        <S.Slide>
          <img src={image1} alt="" />
        </S.Slide>
      </Carousel>
    </S.Content>
  </S.Container>
}
